import { Injectable } from '@angular/core';
import { Adapter } from 'src/app/core/adapter';
import { Model } from 'src/app/core/models/model';
import { StatsElement } from 'src/app/core/models/placestats.model';
import { UtilsService } from 'src/app/shared/services/utils.service';



export class MeterUsage implements Model {

    static TRANSLATIONS = {
        'dishwasher' : $localize `dishwasher`,
        'mix' : $localize `mix`,
        'other' : $localize `other`,
        'shower' : $localize `shower`,
        'toilet' : $localize `toilet`,
        'washing_machine' : $localize `washing machine`,
        'watering' : $localize `watering`
    }
 
    constructor(
        public dishwasher: number,
        public mix: number,
        public other: number,
        public shower: number,
        public tap: number,
        public toilet: number,
        public washing_machine: number,
        public watering: number
    ) { }
}


@Injectable({
    providedIn: 'root'
})
export class MeterUsageAdapter implements Adapter<MeterUsage> {


    adapt(item: any): MeterUsage {
        return new MeterUsage(
            item.dishwasher,
            item.mix,
            item.other,
            item.shower,
            item.tap,
            item.toilet,
            item.washing_machine,
            item.watering
        );
    }
}